<template>
  <div>
    <b-loading
        v-model="isLoading"
        :can-cancel="false"
        :is-full-page="true"
    ></b-loading>
    <div style="background: #eeeeee;">
      <transition name="fade" mode="out-in" v-if="selectedBlurringProject === null">
        <search-box-blurring ref="searchBoxBlurring" style="margin-top: 150px"
                              @onToggleSelectedProject="onToggleSelectedProject"></search-box-blurring>
      </transition>
      <g-map-blurring @onMapClicked="onMapClicked"></g-map-blurring>

      <div v-if="selectedBlurringProject" class="pb-6">
        <div>
          <div class="is-flex has-background-white title-box p-2">
            <div class="is-size-4 ml-5 mr-2 pt-1 pb-1 has-text-weight-bold">{{ selectedBlurringProject.project.name }}
            </div>
            <b-tooltip class="ml-1 mt-auto mb-auto mr-2" label="Refresh project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button aria-label="refresh"
                        @click="onRefreshClicked">
                <b-icon icon="refresh"></b-icon>
              </b-button>
            </b-tooltip>
            <b-tooltip class="ml-auto mt-auto mb-auto mr-2" label="Close project" :delay="1000" type="is-dark"
                       position="is-top">
              <b-button class="card-header-icon" aria-label="more options"
                        @click="closeProjectOverview">
                <b-icon icon="close"></b-icon>
              </b-button>
            </b-tooltip>
          </div>
          <div class="is-flex is-flex-direction-column p-5" style="padding-bottom: 200px !important;">
            <div class="is-size-6 mb-3 mt-2">Sites and Devices</div>
            <blurring-data-card
                v-for="st in selectedBlurringProject.sites" :key="st._id" :site-data="st"
                :ref="'card_' + st._id"
                :refreshing="refreshingData"
                @onCreateTasksClick="onCreateTasksClick"
                @onRunTasksClick="onRunTasksClick"
                @onDownloadClick="onDownloadClick"
                @onResetClick="onResetClick"
                @onShowError="onShowErrors"
            ></blurring-data-card>
          </div>
        </div>
      </div>
    </div>
    <download-file ref="downloadVideos" class="ml-2"></download-file>

    <b-modal v-model="showDownloadDialog" has-modal-card :can-close="true">
      <div class="modal-card" style="width: 500px">
        <header class="modal-card-head">
          <p class="modal-card-title">Download Files</p>
          <button class="delete" aria-label="close" @click="showDownloadDialog = false"></button>
        </header>
        <section class="modal-card-body">
          <p class="mb-3">Which files do you want to download?</p>
          <div class="is-flex is-flex-direction-column" style="gap: 8px">
            <div class="is-flex is-justify-content-space-between">
              <span>CSV files (Pedestrian Data)</span>
              <b-tag :type="downloadCsvCount > 0 ? 'is-success' : 'is-light'">{{ downloadCsvCount }} file(s)</b-tag>
            </div>
            <div class="is-flex is-justify-content-space-between">
              <span>Video files (Blurred Videos)</span>
              <b-tag :type="downloadVideoCount > 0 ? 'is-success' : 'is-light'">{{ downloadVideoCount }} file(s)</b-tag>
            </div>
          </div>
        </section>
        <footer class="modal-card-foot is-flex is-justify-content-space-between">
          <b-button @click="showDownloadDialog = false">Cancel</b-button>
          <div>
            <b-button type="is-info" outlined @click="onDownloadConfirm(true)" :disabled="downloadCsvCount === 0">Only CSV</b-button>
            <b-button type="is-info" @click="onDownloadConfirm(false)" :disabled="downloadCsvCount === 0 && downloadVideoCount === 0">All Files</b-button>
          </div>
        </footer>
      </div>
    </b-modal>
  </div>
</template>

<script>
import {mapActions, mapGetters} from "vuex";
import SearchBoxBlurring
  from "@/modules/dtp-blurring-videos-module/components/search-box-blurring/search-box-blurring.vue";
import BlurringDataCard
  from "@/modules/dtp-blurring-videos-module/components/blurring-data-card/blurring-data-card.vue";
import GMapBlurring
  from "@/modules/dtp-blurring-videos-module/components/g-map-blurring/g-map-blurring.vue";
import DownloadFile from "@/components/download-file/download-file.vue";

export default {
  name: "dtp-blurring-videos-page",
  components: {
    DownloadFile,
    GMapBlurring,
    BlurringDataCard,
    SearchBoxBlurring
  },
  data() {
    return {
      isLoading: false,
      refreshingData: false,
      timer: null,
      count: 0,
      refreshSeconds: 60,
      progress: 0,
      showDownloadDialog: false,
      downloadSiteData: null,
      downloadPedDataResponse: null,
      downloadVideoResponse: null
    }
  },
  mounted() {
    this.timer = setInterval(() => {
      if (!this.refreshingData && this.hasRunningSites) {
        this.count++
        this.progress = this.count / this.refreshSeconds * 100
        this.updateCardProgress(this.progress)
        if (this.count === this.refreshSeconds) {
          this.count = 0
          this.progress = 0
          this.refreshData()
        }
      }
    }, 1000)
  },
  beforeDestroy() {
    clearInterval(this.timer)
    this.timer = null
    this.count = 0
  },
  methods: {
    ...mapActions({
      setSelectedBlurringProject: 'dtpBlurringVideosModule/setSelectedBlurringProject',
      createBlurringTasks: 'dtpBlurringVideosModule/createBlurringTasks',
      runBlurringTasks: 'dtpBlurringVideosModule/runBlurringTasks',
      resetBlurringTasks: 'dtpBlurringVideosModule/resetBlurringTasks',
      downloadBlurringVideos: 'dtpBlurringVideosModule/downloadBlurringVideos',
      downloadManualPedData: 'dtpBlurringVideosModule/downloadManualPedData',
    }),
    updateCardProgress(progress) {
      if (this.selectedBlurringProject && this.selectedBlurringProject.sites) {
        this.selectedBlurringProject.sites.forEach(site => {
          if (site.tasks && site.tasks.status === 'RUNNING') {
            let ref = this.$refs['card_' + site._id]
            if (ref && ref[0]) {
              ref[0].setProgress(progress)
            }
          }
        })
      }
    },
    async refreshData() {
      if (this.selectedBlurringProject) {
        this.refreshingData = true
        await this.setSelectedBlurringProject(this.selectedBlurringProject.project)
        this.refreshingData = false
      }
    },
    async onRefreshClicked() {
      this.isLoading = true
      await this.setSelectedBlurringProject(this.selectedBlurringProject.project)
      this.isLoading = false
    },
    async onToggleSelectedProject(project) {
      if (project === null) {
        await this.setSelectedBlurringProject(null)
      } else {
        this.isLoading = true
        await this.setSelectedBlurringProject(project)
        this.isLoading = false
      }
    },
    async onCreateTasksClick(siteData) {
      console.log('On create tasks click: ', siteData)
      this.isLoading = true
      let response = await this.createBlurringTasks(siteData._id)

      if (response instanceof Error) {
        this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
      } else if (response) {
        this.showCreateTasksSummary(response)
      }

      await this.sleep(2000)
      await this.onRefreshClicked()
      this.isLoading = false
    },
    showCreateTasksSummary(response) {
      let deviceRows = ''
      if (response.devices && response.devices.length > 0) {
        deviceRows = response.devices.map(d =>
            `<tr>
              <td>${d.name}</td>
              <td style="text-align:center">${d.videos}</td>
              <td style="text-align:center">${d.created}</td>
              <td style="text-align:center">${d.skipped}</td>
            </tr>`
        ).join('')
      }

      const hasCreated = response.totalCreated > 0
      const statusText = hasCreated
          ? `<span style="color:#1CAB80;font-weight:bold">${response.totalCreated} task(s) created</span>`
          : `<span style="color:#e02c2c;font-weight:bold">No tasks created</span>`

      const message = `
        <div style="text-align:left">
          <p><b>Site:</b> ${response.siteName || 'N/A'}</p>
          <p style="margin-top:8px">${statusText}, ${response.totalSkipped} skipped</p>
          <table class="table is-narrow is-fullwidth mt-3" style="font-size:13px">
            <thead>
              <tr>
                <th>Device</th>
                <th style="text-align:center">Videos</th>
                <th style="text-align:center">Created</th>
                <th style="text-align:center">Skipped</th>
              </tr>
            </thead>
            <tbody>${deviceRows}</tbody>
          </table>
          ${!hasCreated ? '<p class="has-text-grey" style="margin-top:8px;font-size:12px">No video files found for this site. Please ensure videos are uploaded before creating tasks.</p>' : ''}
        </div>`

      this.$buefy.dialog.alert({
        title: 'Create Tasks Summary',
        message: message,
        type: hasCreated ? 'is-success' : 'is-warning',
        ariaRole: 'alertdialog',
        ariaModal: true
      })
    },
    async sleep(ms) {
      return new Promise(resolve => setTimeout(resolve, ms))
    },
    async onRunTasksClick(siteData) {
      console.log('On run tasks click: ', siteData)
      this.isLoading = true
      let response = await this.runBlurringTasks(siteData.taskIds)

      if (response instanceof Error) {
        this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Blurring tasks started successfully', 'is-success')
      }

      await this.sleep(2000)
      await this.onRefreshClicked()
      this.isLoading = false
    },
    async onDownloadClick(siteData) {
      console.log('On download click: ', siteData)
      this.isLoading = true
      let pedDataResponse = await this.downloadManualPedData(siteData._id)
      let videoResponse = await this.downloadBlurringVideos(siteData._id)
      this.isLoading = false

      this.downloadSiteData = siteData
      this.downloadPedDataResponse = (pedDataResponse instanceof Error) ? null : pedDataResponse
      this.downloadVideoResponse = (videoResponse instanceof Error) ? null : videoResponse

      if (!this.downloadPedDataResponse && !this.downloadVideoResponse) {
        this.showSnackBar('No files available for download', 'is-warning')
        return
      }

      this.showDownloadDialog = true
    },
    async onDownloadConfirm(csvOnly) {
      this.showDownloadDialog = false
      try {
        await this.$nextTick()
        let files = []

        if (this.downloadPedDataResponse && this.downloadPedDataResponse.url) {
          const siteName = this.downloadPedDataResponse.siteName || this.downloadSiteData.name
          files.push({
            name: `${siteName} RoadUsers.csv`,
            url: this.downloadPedDataResponse.url,
            path: `${siteName}/RoadUsers.csv`
          })
        }

        if (!csvOnly && this.downloadVideoResponse && this.downloadVideoResponse.links && this.downloadVideoResponse.links.length > 0) {
          this.downloadVideoResponse.links.forEach(link => {
            files.push({
              name: link.fileName,
              url: link.url,
              path: link.deviceName + '/' + link.fileName
            })
          })
        }

        if (files.length > 0) {
          const siteName = this.downloadSiteData.name
          await this.$refs.downloadVideos.downloadFiles(files, siteName)
        } else {
          this.showSnackBar('No files available for download', 'is-warning')
        }
      } catch (e) {
        console.error('Download error:', e)
        this.showSnackBar(`ERROR: ${e.message}`, 'is-danger')
      }
    },
    onResetClick(siteData) {
      this.$buefy.dialog.confirm({
        title: 'Reset Blurring Tasks',
        message: `Are you sure you want to reset all blurring tasks for <b>${siteData.name}</b>? This action cannot be undone.`,
        confirmText: 'Reset',
        type: 'is-danger',
        hasIcon: true,
        onConfirm: () => this.resetSite(siteData)
      })
    },
    async resetSite(siteData) {
      console.log('On reset click: ', siteData)
      this.isLoading = true
      let response = await this.resetBlurringTasks({projectId: this.selectedBlurringProject.project._id, siteId: siteData._id})

      if (response instanceof Error) {
        this.showSnackBar(`ERROR: ${response.message}`, 'is-danger')
      } else {
        this.showToast('Tasks reset successfully', 'is-success')
      }

      await this.sleep(2000)
      await this.onRefreshClicked()
      this.isLoading = false
    },
    onShowErrors(errors) {
      console.log('On show errors', errors)
    },
    onMapClicked() {
      if (this.$refs.searchBoxBlurring) {
        this.$refs.searchBoxBlurring.onClickedOutside()
      }
    },
    closeProjectOverview() {
      this.setSelectedBlurringProject(null)
    },
    showToast(message, type) {
      this.$buefy.toast.open({
        message: message,
        duration: 3000,
        type: type
      })
    },
    showSnackBar(message, type) {
      this.$buefy.snackbar.open({
        message: message,
        type: type,
        position: 'is-top',
        actionText: 'Ok',
        indefinite: true,
      })
    },
  },
  computed: {
    ...mapGetters({
      selectedBlurringProject: 'dtpBlurringVideosModule/getSelectedBlurringProject',
    }),
    downloadCsvCount() {
      return this.downloadPedDataResponse && this.downloadPedDataResponse.url ? 1 : 0
    },
    downloadVideoCount() {
      return (this.downloadVideoResponse && this.downloadVideoResponse.links) ? this.downloadVideoResponse.links.length : 0
    },
    hasRunningSites() {
      if (this.selectedBlurringProject && this.selectedBlurringProject.sites) {
        return this.selectedBlurringProject.sites.some(site =>
            site.tasks && site.tasks.status !== 'COMPLETED' && site.tasks.status !== 'FAILED' && site.tasks.status !== 'CREATED'
        )
      }
      return false
    }
  }
}
</script>

<style scoped>
.title-box {
  background-color: hsl(0deg, 0%, 100%);
  border-radius: 0;
  box-shadow: 0 0.125em 0.5em -0.125em rgb(10 10 10 / 10%), 0 0px 0 1px rgb(10 10 10 / 2%);
  color: hsl(0deg, 0%, 29%);
  display: block;
  padding: 1.25rem;
}
</style>
